module.exports = __webpack_public_path__ + "static/media/maskGroup3.bc071481.png";